import { Svg } from '../../utils/IconBase';
import { IconProps } from '../../utils/icon';

const IconXFill = ({ width = 24, height = 24, fill = '#1D2225', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fill={fill}
        d="m10 10.878-4.227 4.228a.605.605 0 0 1-.436.177.59.59 0 0 1-.443-.177.598.598 0 0 1-.18-.44c0-.171.06-.318.18-.439L9.122 10 4.894 5.772a.605.605 0 0 1-.177-.435.59.59 0 0 1 .177-.443.598.598 0 0 1 .44-.181c.171 0 .318.06.439.18L10 9.123l4.227-4.228a.605.605 0 0 1 .436-.177.59.59 0 0 1 .443.177c.12.12.18.267.18.44a.6.6 0 0 1-.18.438L10.878 10l4.228 4.227c.115.116.174.26.177.435a.59.59 0 0 1-.177.444.598.598 0 0 1-.44.18.598.598 0 0 1-.439-.18L10 10.878Z"
      />
    </Svg>
  );
};

export default IconXFill;
